module.exports = __webpack_public_path__ + "static/img/icon3-8.9eac5aff.png";